import React from "react";
import { RCCCheckBox, RCCGrid , RCCHookToast, RCCProgress, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { v4 } from "uuid";
import { IComponentListChild } from "../interface";

const ListChild: React.FC<IComponentListChild> = ({
	data
}) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const { register } = useForm();

	const onChangeCheckboxExceeded = async (selected: boolean, id: number) => {
		try{
			await RCCServicesApi.putRequest({
				method: "CommercialPlans/UpdateExceeded",
				urlParameters: {
					exceeded: selected ? "S" : "N",
					efa012Id: id
				}
			});
			addToast({
				color: "green",
				description: translate("Bloquear excedido alterado com sucesso"),
				title: translate("Sucesso")
			});

		}catch(err){
			standardErrorMessages(err, translate("Erro ao alterar valor"), addToast);
		}
	};

	const colQuantity = (row: any) => {

		const getColor = (amount: number) => {
			if(amount > 1)
				return "red";
			if(amount <= 1 && amount > 0.75)
				return "yellow";
			return "green";
		};

		const amount = row.efa012Valor > 0 ? row.quantityUtilized / row.efa012Valor : 0;
		const color = getColor(amount);

		return (
			<>
				<div
					style={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", background: `var(--${color})`}}
				/>
				<RCCGrid container item justifyContent="center" alignItems="center">
					<RCCGrid container item justifyContent="center" style={{margin: "0.5rem 0", maxWidth: "calc(100% - 280px)"}}>
						{row.efa012Valor > 0 && (
							<RCCProgress 
								value={Number((amount * 100).toFixed(2))} 
								layout="line"
								color={`var(--${color})`}
							/>
						)}
					</RCCGrid>
					<RCCGrid container item alignItems="center" justifyContent="center" style={{ maxWidth: "180px" }}>
						<RCCCheckBox 
							name={`efa012Bloqexcedido-${v4()}`}
							defaultChecked={row.efa012Bloqexcedido === "S"}
							label={translate("Bloquear Excedido")}
							labelPosition="end"
							register={register}
							onChangeCapture={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCheckboxExceeded(e.target.checked, row.efa012Id)}
						/>
					</RCCGrid>
					<RCCGrid container item alignItems="center" justifyContent="center" style={{ maxWidth: "100px" }}>
						{row.efa012Valor > 0 ? 
							<p>
								{row.quantityUtilized} / {row.efa012Valor}
							</p>: 
							<p>{row.quantityUtilized}</p>
						}
					</RCCGrid>
				</RCCGrid>
			</>		
		);
	};

	const titleListChild = (row: any) => (
		<>
			<RCCGrid
				container
				item
				style={{ marginLeft: "20px" }}
			>
				{translate(row.efa016Descricao)}
			</RCCGrid>	
		</>
	);



	return (
		<>
			<List 
				data={data.eftba012 ? data?.eftba012?.filter((x) => x.efa012Valor > 0) : []}
				layout="table"
				columns={[{
					idColumn: "efa016Descricao",
					nameColumn: "",
					xs: 12,
					sm: 6,
					justify: "left",
					cellRenderer: titleListChild
				},{
					idColumn: "quantityUtilized",
					nameColumn: "",
					xs: 12,
					sm: 6,
					justify: "left",
					cellRenderer: colQuantity
				}]}
			/>	
		</>
	);
};

export default ListChild;
